(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.mobileMediaQuery.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((predictiveSearch) => predictiveSearch.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((searchModal) => searchModal.close(false));
    }
  }

  // The account `open` event is composed but does not bubble, so listen during capture.
  // Anchor the dialog to the bottom of the account button itself. The header group can be
  // much taller than the button's row (for example, a top-left logo pushes the menu to a
  // second row), so anchoring to the section bottom drops the dialog too low.
  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  customElements.define('sticky-header', StickyHeader);

  const initIslaMobileBookingCTA = () => {
    const config = document.querySelector('[data-isla-booking-config]');
    if (!config || config.dataset.enabled !== 'true') return;

    const drawer = document.querySelector('header-drawer');
    if (!drawer || drawer.querySelector('.isla-mobile-book-cta')) return;

    const destination =
      drawer.querySelector('.menu-drawer__navigation-container') ||
      drawer.querySelector('.menu-drawer__navigation');

    if (!destination) return;

    const link = document.createElement('a');
    link.className = 'isla-mobile-book-cta';
    link.href = config.dataset.url || '/pages/experiences';
    link.textContent = `${config.dataset.label || 'Book now'} →`;
    destination.appendChild(link);
  };

  document.addEventListener('DOMContentLoaded', initIslaMobileBookingCTA);
  document.addEventListener('shopify:section:load', initIslaMobileBookingCTA);


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["isla-something-els"] && !Shopify.designMode) return;
  try {
    
document.querySelectorAll('[data-se-stay]').forEach(root=>{
  if(root.dataset.ready==='true')return;root.dataset.ready='true';
  const base=root.dataset.api, key=root.dataset.key, property=root.dataset.property, unit=root.dataset.unit;
  const availability=root.querySelector('[data-se-availability]'), guestForm=root.querySelector('[data-se-guest]'), status=root.querySelector('[data-se-status]'), quote=root.querySelector('[data-se-quote]');
  const post=async(slug,body)=>{const r=await fetch(base+'/'+slug,{method:'POST',headers:{'Content-Type':'application/json','apikey':key},body:JSON.stringify(body)});const d=await r.json().catch(()=>({}));if(!r.ok)throw new Error(d.error||'Something went wrong. Please try again.');return d};
  const fmt=n=>new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(Number(n||0));
  let result=null,clientId=localStorage.getItem('ei_stay_session');
  if(!clientId){clientId=(crypto.randomUUID?crypto.randomUUID():'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g,c=>{const r=Math.random()*16|0;return(c==='x'?r:(r&3|8)).toString(16)}));localStorage.setItem('ei_stay_session',clientId)}
  const ci=availability.elements.check_in,co=availability.elements.check_out;
  const calendar=root.querySelector('[data-se-calendar]'),calendarDays=root.querySelector('[data-se-calendar-days]'),calendarMonth=root.querySelector('[data-se-calendar-month]'),calendarStatus=root.querySelector('[data-se-calendar-status]');
  const ciDisplay=root.querySelector('[data-se-date-display="check_in"]'),coDisplay=root.querySelector('[data-se-date-display="check_out"]');
  const now=new Date(),iso=d=>d.getFullYear()+'-'+String(d.getMonth()+1).padStart(2,'0')+'-'+String(d.getDate()).padStart(2,'0');
  const parseDate=s=>new Date(s+'T12:00:00'),addDays=(s,n)=>{const d=parseDate(s);d.setDate(d.getDate()+n);return iso(d)};
  const today=iso(now),rangeEnd=(()=>{const d=new Date(now);d.setDate(d.getDate()+365);return iso(d)})();
  let unavailableDates=new Set(),calendarLoaded=false,calendarLoading=false,calendarMode='check_in',shownMonth=new Date(now.getFullYear(),now.getMonth(),1);
  const unavailableHas=s=>unavailableDates.has(s);
  function checkoutBlocked(s){if(!ci.value||s<addDays(ci.value,3))return true;for(let d=ci.value;d<s;d=addDays(d,1))if(unavailableHas(d))return true;return false}
  function cannotStart(value){for(let d=value;d<addDays(value,3);d=addDays(d,1))if(unavailableHas(d))return true;return false}
  function updateDisplays(){const fmtDate=s=>s?new Intl.DateTimeFormat('en-GB',{day:'numeric',month:'short',year:'numeric'}).format(parseDate(s)):'';ciDisplay.value=fmtDate(ci.value);coDisplay.value=fmtDate(co.value)}
  function renderCalendar(){
    calendarMonth.textContent=new Intl.DateTimeFormat('en-US',{month:'long',year:'numeric'}).format(shownMonth);calendarDays.replaceChildren();
    const first=new Date(shownMonth.getFullYear(),shownMonth.getMonth(),1),last=new Date(shownMonth.getFullYear(),shownMonth.getMonth()+1,0),offset=(first.getDay()+6)%7;
    for(let i=0;i<offset;i++){const blank=document.createElement('span');blank.className='isla-calendar__day is-empty';blank.setAttribute('aria-hidden','true');calendarDays.append(blank)}
    for(let day=1;day<=last.getDate();day++){
      const d=new Date(shownMonth.getFullYear(),shownMonth.getMonth(),day),value=iso(d),busy=unavailableHas(value),past=value<today,button=document.createElement('button');
      button.type='button';button.className='isla-calendar__day';button.textContent=String(day);button.dataset.date=value;
      const isCurrentCheckIn=calendarMode==='check_out'&&value===ci.value;
      const validCheckout=calendarMode==='check_out'&&ci.value&&value>=addDays(ci.value,3)&&!checkoutBlocked(value);
      const unavailableForChoice=calendarMode==='check_in'?cannotStart(value):checkoutBlocked(value)&&!isCurrentCheckIn;
      const crossOut=(past||busy||unavailableForChoice)&&!validCheckout&&!isCurrentCheckIn;
      if(crossOut)button.classList.add(past?'is-past':'is-unavailable');
      if(value===ci.value||value===co.value)button.classList.add('is-selected');
      if(ci.value&&co.value&&value>ci.value&&value<co.value)button.classList.add('is-range');
      button.disabled=!calendarLoaded||past||unavailableForChoice;
      if(busy&&validCheckout)button.title='Unavailable overnight; check-out is allowed on this date';
      button.setAttribute('aria-label',new Intl.DateTimeFormat('en-US',{weekday:'long',year:'numeric',month:'long',day:'numeric'}).format(d)+(crossOut?', unavailable overnight':''));
      button.addEventListener('click',()=>{
        if(calendarMode==='check_out'&&value===ci.value){ci.value='';co.value='';calendarMode='check_in';calendarStatus.textContent='Choose your check-in date.'}
        else if(calendarMode==='check_in'){ci.value=value;co.value='';calendarMode='check_out';calendarStatus.textContent='Now choose your check-out date. Minimum stay: 3 nights.'}
        else {co.value=value;calendarMode='check_in';calendarStatus.textContent='Dates selected. Availability and price are checked again when you continue.'}
        updateDisplays();quote.hidden=true;guestForm.hidden=true;result=null;renderCalendar();
      });
      calendarDays.append(button);
    }
    const minMonth=new Date(now.getFullYear(),now.getMonth(),1),maxDate=parseDate(rangeEnd),maxMonth=new Date(maxDate.getFullYear(),maxDate.getMonth(),1);
    calendar.querySelector('[data-se-calendar-prev]').disabled=shownMonth<=minMonth;calendar.querySelector('[data-se-calendar-next]').disabled=shownMonth>=maxMonth;
  }
  async function loadCalendar(){if(calendarLoaded||calendarLoading)return;calendarLoading=true;calendarStatus.textContent='Loading booked dates…';try{const data=await post('accommodations-calendar',{property_id:property,unit_id:unit,from:today,to:rangeEnd});if(data.status!=='ok'||!Array.isArray(data.unavailable_dates))throw new Error(data.error||'Calendar data is unavailable.');unavailableDates=new Set(data.unavailable_dates);calendarLoaded=true;calendarStatus.textContent='Booked nights are crossed out. Dates are checked again before checkout.';renderCalendar()}catch(err){calendarStatus.textContent='Could not load booked dates. Please try again later.';renderCalendar()}finally{calendarLoading=false}}
  calendar.querySelector('[data-se-calendar-prev]').addEventListener('click',()=>{shownMonth=new Date(shownMonth.getFullYear(),shownMonth.getMonth()-1,1);renderCalendar()});
  calendar.querySelector('[data-se-calendar-next]').addEventListener('click',()=>{shownMonth=new Date(shownMonth.getFullYear(),shownMonth.getMonth()+1,1);renderCalendar()});
  updateDisplays();renderCalendar();loadCalendar();
  root.querySelector('[data-gallery-prev]').addEventListener('click',()=>root.querySelector('[data-photo-gallery]').scrollBy({left:-root.querySelector('[data-photo-gallery]').clientWidth*.82,behavior:'smooth'}));
  root.querySelector('[data-gallery-next]').addEventListener('click',()=>root.querySelector('[data-photo-gallery]').scrollBy({left:root.querySelector('[data-photo-gallery]').clientWidth*.82,behavior:'smooth'}));
  availability.addEventListener('submit',async e=>{
    e.preventDefault();
    if(!ci.value||!co.value){status.classList.add('is-error');status.textContent='Choose a check-in and check-out date in the calendar.';return}
    if(co.value<addDays(ci.value,3)||checkoutBlocked(co.value)){status.classList.add('is-error');status.textContent='Those dates include an unavailable night or are shorter than 3 nights.';return}
    guestForm.hidden=true;quote.hidden=true;result=null;status.classList.remove('is-error');status.textContent='Checking the calendar and calculating your total…';
    try{
      const payload={property_id:property,unit_id:unit,check_in:ci.value,check_out:co.value,guests:Number(availability.elements.guests.value)};
      const data=await post('accommodations-availability',payload);
      if(data.status!=='available')throw new Error(data.message||'Those dates are not available.');
      result=payload;quote.hidden=false;guestForm.hidden=false;status.textContent='Available for your dates.';
      root.querySelector('[data-se-nights]').textContent=data.nights+' nights';
      root.querySelector('[data-se-subtotal]').textContent=fmt(data.accommodation_subtotal-data.cleaning_fee);
      root.querySelector('[data-se-cleaning]').textContent=fmt(data.cleaning_fee);
      const weekendAmount=Math.max(0,Number(data.accommodation_subtotal)-Number(data.cleaning_fee)-Number(data.base_nightly_rate)*Number(data.nights));
      root.querySelector('[data-se-weekend]').textContent=fmt(weekendAmount)+' ('+data.weekend_nights+' Fri/Sat nights)';
      root.querySelector('[data-se-total]').textContent=fmt(data.total_amount);
    }catch(err){status.classList.add('is-error');status.textContent=err.message}
  });
  guestForm.addEventListener('submit',async e=>{
    e.preventDefault();if(!result)return;
    const button=guestForm.querySelector('button[type=submit]');button.disabled=true;button.textContent='Creating secure checkout…';status.classList.remove('is-error');status.textContent='Reserving your dates…';
    const fields=Object.fromEntries(new FormData(guestForm).entries());
    try{
      const hold=await post('accommodations-hold',{action:'create',property_id:property,unit_id:unit,client_session_id:clientId,check_in:result.check_in,check_out:result.check_out,guests:result.guests,locale:document.documentElement.lang||'en'});
      if(!hold.hold_token)throw new Error(hold.message||'Those dates could not be held. Please check availability again.');
      const checkout=await post('accommodations-checkout',{hold_token:hold.hold_token,client_session_id:clientId,guest_first_name:fields.guest_first_name,guest_last_name:fields.guest_last_name,guest_email:fields.guest_email,guest_phone:fields.guest_phone,guest_notes:fields.guest_notes||'',terms_accepted:true,cancellation_accepted:true,privacy_accepted:true,locale:document.documentElement.lang||'en'});
      if(!checkout.checkout_url)throw new Error(checkout.error||'A secure checkout link could not be created.');
      window.location.assign(checkout.checkout_url);
    }catch(err){button.disabled=false;button.textContent='Continue to secure checkout';status.classList.add('is-error');status.textContent=err.message}
  });
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["isla-stays-hub"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-stays-search]').forEach((form) => {
    const root = form.closest('.isla-stays');
    if (!root || root.dataset.ready === 'true') return;
    root.dataset.ready = 'true';
    const cards = [...root.querySelectorAll('[data-stay-card]')];
    const message = root.querySelector('[data-stays-message]');
    const empty = root.querySelector('[data-empty]');
    const clear = root.querySelector('[data-clear-search]');
    const setStayLinks = (card, searchParams) => {
      card.querySelectorAll('[data-stay-link]').forEach((link) => {
        if (!link.dataset.baseHref) link.dataset.baseHref = link.getAttribute('href');
        const url = new URL(link.dataset.baseHref, window.location.origin);
        url.search = searchParams ? searchParams.toString() : '';
        link.href = url.pathname + url.search;
      });
    };
    const today = new Date();
    const tomorrow = new Date(today); tomorrow.setDate(today.getDate() + 1);
    const iso = (date) => date.toISOString().slice(0, 10);
    const checkIn = form.elements.check_in;
    const checkOut = form.elements.check_out;
    checkIn.min = iso(today); checkOut.min = iso(tomorrow);
    checkIn.addEventListener('change', () => { const next = new Date(`${checkIn.value}T12:00:00`); next.setDate(next.getDate() + 2); checkOut.min = iso(next); if (!checkOut.value || checkOut.value < checkOut.min) checkOut.value = checkOut.min; });
    const intervalFree = (blocked, start, end) => { const day = new Date(`${start}T12:00:00Z`); const stop = new Date(`${end}T12:00:00Z`); while (day < stop) { if (blocked.has(day.toISOString().slice(0, 10))) return false; day.setUTCDate(day.getUTCDate() + 1); } return true; };
    form.addEventListener('submit', async (event) => {
      event.preventDefault();
      if (!form.reportValidity()) return;
      if ((new Date(checkOut.value) - new Date(checkIn.value)) / 86400000 < 2) { message.textContent = 'The minimum stay is 2 nights.'; return; }
      message.textContent = 'Checking live availability…'; clear.hidden = false;
      let visible = 0;
      await Promise.all(cards.map(async (card) => {
        const status = card.querySelector('[data-availability]');
        if (Number(form.elements.guests.value) > Number(card.dataset.capacity)) { card.hidden = true; return; }
        const units = card.dataset.units.split(',').map((unit) => unit.trim()).filter(Boolean);
        try {
          const results = await Promise.all(units.map((unitId) => fetch(root.dataset.api, {method:'POST',headers:{'Content-Type':'application/json'},body:JSON.stringify({property_id:card.dataset.property,unit_id:unitId,from:checkIn.value,to:checkOut.value})}).then((response) => response.ok ? response.json() : Promise.reject())));
          const availableUnits = results.map((result, index) => intervalFree(new Set(result.unavailable_dates || []), checkIn.value, checkOut.value) ? units[index] : null).filter(Boolean);
          const available = availableUnits.length;
          const stayParams = new URLSearchParams({
            check_in: checkIn.value,
            check_out: checkOut.value,
            guests: form.elements.guests.value,
            available_units: availableUnits.join(',')
          });
          setStayLinks(card, stayParams);
          card.hidden = available === 0; status.classList.toggle('is-unavailable', available === 0); status.textContent = available ? `${available} apartment${available === 1 ? '' : 's'} available for these dates` : 'Unavailable for these dates';
          if (available) visible += 1;
        } catch (_) { card.hidden = false; status.textContent = 'Open this stay to check availability'; visible += 1; }
      }));
      empty.hidden = visible > 0; message.textContent = visible ? `${visible} stay${visible === 1 ? '' : 's'} available for your dates.` : 'No available stays found for these dates.';
    });
    clear.addEventListener('click', () => {
      form.reset();
      cards.forEach((card) => {
        card.hidden = false;
        setStayLinks(card, null);
        card.querySelector('[data-availability]').textContent = 'Enter dates to check availability';
      });
      empty.hidden = true;
      clear.hidden = true;
      message.textContent = 'Choose dates to see live availability.';
      window.history.replaceState({}, '', window.location.pathname);
    });
    const incoming = new URLSearchParams(window.location.search);
    const incomingCheckIn = incoming.get('check_in');
    const incomingCheckOut = incoming.get('check_out');
    const incomingGuests = incoming.get('guests');
    if (incomingCheckIn && incomingCheckOut) {
      checkIn.value = incomingCheckIn;
      checkOut.value = incomingCheckOut;
      if (incomingGuests && form.elements.guests.querySelector(`option[value="${incomingGuests}"]`)) form.elements.guests.value = incomingGuests;
      requestAnimationFrame(() => form.requestSubmit());
    }
  });

  } catch(e) { console.error(e); }
})();
})();
